import TableRow from '@tiptap/extension-table-row';

export const TimeWebkitTableRowExtension = TableRow;
